<template>
  <div class="plan-wrap" v-loading="loading" customClass="loadingclass">
    <div class="plan-header">
      <el-button @click="backTable" class="back-btn" type="text" icon="el-icon-arrow-left"
        >返回</el-button
      >
    </div>
    <div class="plan-main">
      <div class="left-step">
        <Step ref="stepRef" @changeStep="scrollToView"></Step>
      </div>
      <div class="plan-content">
        <div class="content-scroll">
          <div class="plan-center-content">
            <!-- 模板 -->
            <header-tpl ref="headerTplRef" @changeAdCount="changeAdCount"></header-tpl>
            <!-- 广告系列 -->
            <div class="setp-wrap" id="step1">
              <ad-series ref="adSeriesRef" @confirmeAdSeries="confirmeAdSeries"></ad-series>
            </div>
            <!-- 地区 -->
            <div class="setp-wrap" id="step2">
              <region-pkg ref="regionPkgRef"></region-pkg>
            </div>
            <!--出价 -->
            <div class="setp-wrap" id="step3">
              <bid-group ref="bidRef"></bid-group>
            </div>
            <!-- 广告组 -->
            <div class="setp-wrap" id="step4">
              <ad-group ref="adGroupRef"></ad-group>
            </div>
            <!-- 创意组 -->
            <div class="setp-wrap" id="step5">
              <create-group ref="creategroupRef"></create-group>
            </div>
            <div class="button-list">
              <el-button class="my-btn" type="primary" @click="toPreview">提交预览</el-button>
              <el-button class="my-btn border-btn" @click="showModal">保存模板</el-button>
              <el-button class="my-btn border-btn" @click="saveDraft(true)">保存草稿</el-button>
              <el-button class="my-btn border-btn" @click="resetAllData">全部重置</el-button>
            </div>
          </div>
          <!-- 分配规则 -->
          <div class="num-table-wrap">
            <allocation-rule></allocation-rule>
          </div>
        </div>
      </div>
    </div>

    <!-- 保存模板弹框 -->
    <el-dialog
      title="保存模板"
      :visible.sync="showSaveModal"
      :close-on-click-modal="false"
      width="450px"
    >
      <div class="modal-body">
        <el-form :model="saveModalData" label-width="80px" :rules="rules" ref="saveModalRef">
          <el-form-item label="保存方式:" v-show="showSaveMethods">
            <el-radio-group v-model="saveModalData.isAdd" class="radio-group">
              <el-radio :label="0">更新模板</el-radio>
              <el-radio :label="1">另存为模板</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="模板名称:" prop="templateName">
            <el-input
              :disabled="saveModalData.isAdd === 0"
              v-model="saveModalData.templateName"
              placeholder="请输入模板名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="描述:">
            <el-input
              type="textarea"
              v-model="saveModalData.templateDesc"
              placeholder="请输入描述"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="footer-wrap">
          <el-button @click="showSaveModal = false">取 消</el-button>
          <el-button type="primary" @click="saveTpl">确 定</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Step from "./subPlan/step.vue";
import HeaderTpl from "./subPlan/headerTpl.vue";
import AdSeries from "./subPlan/adSeries.vue";
import RegionPkg from "./subPlan/regionPkg.vue";
import BidGroup from "./subPlan/bidGroup.vue";
import AdGroup from "./subPlan/adGroup.vue";
import CreateGroup from "./subPlan/creativeGroup.vue";
import AllocationRule from "./subPlan/allocationRules.vue";
import { mapState } from "vuex";
import {
  previewGoogle,
  saveAdCommonDraft,
  getAdCommonDraftDetail,
  deleteAdCommonDraft,
} from "@/api/promotion-google.js";
import { createTemplate } from "@/api/promotion-gdt.js";
export default {
  components: {
    Step,
    HeaderTpl,
    AdSeries,
    RegionPkg,
    BidGroup,
    AdGroup,
    CreateGroup,
    AllocationRule,
  },
  data() {
    return {
      isRefresh: false,
      loading: false,
      showSaveModal: false,
      showSaveMethods: false,
      saveModalData: {
        templateName: "",
        templateDesc: "",
        id: null,
        isAdd: 1, //1新增， 0覆盖
      },
      fromRountObj: {},
      rules: {
        templateName: [{ required: true, message: "模板名称必填", trigger: "blur" }],
      },
    };
  },
  methods: {
    scrollToView(step) {
      let element = document.getElementsByClassName("content-scroll")[0];
      let height = document.getElementById("step" + step).offsetTop - 10; //计算需要向上移动的距离
      element.scroll({
        top: height,
        behavior: "smooth",
      });
    },
    debounce(fn, wait) {
      var timer = null;
      return function () {
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(fn, wait);
      };
    },
    listenScroll() {
      let content = document.getElementsByClassName("content-scroll")[0];
      let that = this;
      content.addEventListener(
        "scroll",
        this.debounce(function () {
          let flag = true; //是否对比完全部
          for (let i = 1; i <= 6; i++) {
            let el = document.getElementById("step" + i);
            if (el.getBoundingClientRect().top - 180 > 0) {
              let step = i - 1;
              that.$refs.stepRef.curStep = step === 0 ? 1 : step;
              flag = false;
              break;
            }
          }
          if (flag) {
            that.$refs.stepRef.curStep = 6;
          }
        }, 200),
        false
      );
    },
    toPreview() {
      this.checkData()
        .then(() => {
          this.loading = true;
          previewGoogle({
            ...this.PromotionGoogle,
          }).then((res) => {
            this.loading = false;
            if (res.code === "0000") {
              this.$router.push({
                name: "googlePerview",
                query: { templateId: res.data },
              });
            } else {
              this.$message.error("预览失败!!!");
            }
          });
        })
        .catch(() => {
          const element = document.querySelectorAll(".el-form-item__error")[0];
          element?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          this.$message.warning("请检查数据填写是否完整");
        });
    },
    showModal() {
      this.$refs.adSeriesRef
        .checkData()
        .then(() => {
          this.$refs.bidRef.saveInStore();
          this.$refs.adGroupRef.saveInStore();
          this.$refs.creategroupRef.saveInStore();
          this.$refs.regionPkgRef.saveData();
          this.saveModalData.templateName = "";
          this.saveModalData.templateDesc = "";
          this.saveModalData.isAdd = 1;
          let tplMsg = this.$refs.headerTplRef.tplMsg;
          if (tplMsg.tplName !== "") {
            this.showSaveMethods = true;
            this.saveModalData.id = tplMsg.tplId;
            this.saveModalData.templateName = tplMsg.tplName;
            this.saveModalData.templateDesc = tplMsg.tplDes;
            this.saveModalData.isAdd = 0;
          }
          this.showSaveModal = true;
        })
        .catch((e) => {
          console.log(e);
          this.$message.warning("项目数据必填");
        });
    },
    saveTpl() {
      this.$refs.saveModalRef.validate((valid) => {
        if (valid) {
          try {
            let tplData = {
              ...this.PromotionGoogle,
            };
            let parmas = {
              templateName: this.saveModalData.templateName,
              templateDesc: this.saveModalData.templateDesc,
              id: this.$refs.headerTplRef.tplMsg?.tplId,
              advertiserIds: this.adCount,
              templateData: JSON.stringify(tplData),
              platform: 5,
            };
            if (this.saveModalData.isAdd === 0) {
              parmas.id = this.saveModalData.id;
            } else {
              delete parmas.id;
            }
            this.loading = true;
            createTemplate(parmas).then((res) => {
              this.loading = false;
              if (res.code === "0000") {
                this.$message({
                  message: "模板保存成功",
                  type: "success",
                });
                this.showSaveModal = false;
              }
            });
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
    resetAllData() {
      this.$confirm("该操作会重置所有表单项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.isRefresh = true;
          deleteAdCommonDraft({
            platType: 5,
          }).then(() => {
            window.location.reload();
          });
        })
        .catch(() => {});
    },
    checkData() {
      console.log(
        "headerTplRef:",
        this.$refs.headerTplRef.checkData(),
        "adSeriesRef:",
        this.$refs.adSeriesRef.checkData(),
        "regionPkgRef:",
        this.$refs.regionPkgRef.checkData(),
        "bidRef:",
        this.$refs.bidRef.checkData(),
        "adGroupRef:",
        this.$refs.adGroupRef.checkData(),
        "creategroupRef:",
        this.$refs.creategroupRef.checkData()
      );
      return Promise.all([
        this.$refs.headerTplRef.checkData(),
        this.$refs.adSeriesRef.checkData(),
        this.$refs.regionPkgRef.checkData(),
        this.$refs.bidRef.checkData(),
        this.$refs.adGroupRef.checkData(),
        this.$refs.creategroupRef.checkData(),
      ]);
    },
    backTable() {
      this.$router.push({
        path: "/promotion.html",
        query: {
          key: "GoogleReport",
        },
      });
    },
    // 改变账号
    changeAdCount() {
      this.$refs.adSeriesRef?.addAdGroup();
    },
    saveDraft(flag = false) {
      this.$refs.adSeriesRef.saveInStore();
      this.$refs.regionPkgRef.saveData();
      this.$refs.bidRef.saveInStore();
      this.$refs.adGroupRef.saveInStore();
      this.$refs.creategroupRef.saveInStore();
      if (this.adCount) {
        saveAdCommonDraft({
          platType: 5,
          draftInfo: JSON.stringify({ ...this.PromotionGoogle }),
        }).then(() => {
          if (flag) this.$message.success("草稿保存成功");
        });
      } else {
        if (flag) this.$message.warning("请选择广告账户");
      }
    },
    // 草稿回显
    renderDraftData(data) {
      const { creativeGroups, draftCampaign, adGroupNameRule, splitRule } = JSON.parse(data);
      this.$store.commit("set_ad_series_google", draftCampaign);
      this.$store.commit("set_creative_groups_google", creativeGroups);
      this.$refs.headerTplRef?.renderDraft(draftCampaign);
      this.$store.commit("set_adGroup_nameRule_google", adGroupNameRule);
      //分配规则
      for (let [field, value] of Object.entries(splitRule)) {
        this.$store.commit("set_split_rule_google", {
          key: field,
          value,
        });
      }
    },
    beforeunloadHandler() {
      if (!this.isRefresh) {
        this.saveDraft();
      }
    },
    async initPlan() {
      const { type, advertiserId, campaignId } = this.$route.query;
      if (type) {
        this.$store.commit("set_ad_series_google", {
          advertiserId,
        });
        this.$refs.headerTplRef?.renderDraft({
          advertiserId,
        });
        if (type === "addGroup") {
          this.loading = true;
          await this.$refs.adSeriesRef?.confirmeSelect({
            advertiserId,
            campaignId,
          });
        }
      } else {
        getAdCommonDraftDetail({
          platType: 5,
        }).then((res) => {
          if (res.data) {
            this.$confirm(`您上次编辑的内容已为您保存至草稿，是否继续编辑！`, "提示", {
              confirmButtonText: "继续编辑",
              cancelButtonText: "重新编辑",
              type: "warning",
              showClose: false,
              closeOnClickModal: false,
            })
              .then(() => {
                this.renderDraftData(res.data);
              })
              .catch(() => {
                this.isRefresh = true;
                deleteAdCommonDraft({
                  platType: 5,
                });
                window.location.reload();
              });
          }
        });
      }
    },
    confirmeAdSeries() {
      this.loading = false;
    },
  },
  computed: {
    ...mapState({
      PromotionGoogle: (state) => state.PromotionGoogle,
      adCount: (state) => state.PromotionGoogle.draftCampaign.advertiserId,
    }),
  },
  mounted() {
    this.listenScroll();
  },
  activated() {
    window.addEventListener("beforeunload", (e) => this.beforeunloadHandler(e)); //监听页面刷新触发事件
    // 从预览页面返回不加载草稿
    if (this.fromRountObj.name !== "googlePerview") {
      this.initPlan();
    }
  },
  deactivated() {
    window.removeEventListener("beforeunload");
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fromRountObj = from;
    });
  },
  async beforeRouteLeave(to, from, next) {
    if (to.name !== "googlePerview") {
      this.$store.commit("set_ad_series_google", {
        campaignId: null,
      });
    }
    await this.saveDraft();
    next();
  },
};
</script>

<style lang="less" scoped>
.plan-wrap {
  .plan-header {
    .back-btn {
      color: rgba(0, 0, 0, 0.85);
      font-weight: 500;
      font-size: 15px;
      margin-left: 16px;
      margin-top: 10px;
      line-height: 30px;
      padding: 0px;
    }
  }
  .plan-main {
    display: flex;
    box-sizing: border-box;
    overflow: auto;
    padding-top: 10px;
    .left-step {
      flex-shrink: 0;
      width: 200px;
      margin: 0 8px 0px 16px;
    }
    .plan-content {
      height: calc(100vh - 92px);
      width: 100%;
      box-sizing: border-box;
      position: relative;
      .content-scroll {
        overflow: auto;
        height: 100%;
        padding: 0px 454px 0px 8px;
        box-sizing: border-box;
        // &::-webkit-scrollbar {
        //   display: none; /* Chrome Safari */
        //   scrollbar-width: none;
        //   -ms-overflow-style: none;
        // }
        .plan-center-content {
          margin: 0 auto;
        }
        .num-table-wrap {
          position: absolute;
          right: 32px;
          top: 0px;
          width: 422px;
          height: calc(100% - 20px);
          display: flex;
          flex-direction: column;
        }
        .button-list {
          padding: 32px;
          position: sticky;
          bottom: 0px;
          background: #fff;
          z-index: 10;
          .my-btn {
            width: 117px;
            height: 40px;
            &.border-btn {
              border: 1px solid rgba(24, 144, 255, 1);
              color: rgba(24, 144, 255, 1);
            }
          }
        }
      }
    }
  }
}

.modal-body {
  .radio-group {
    /deep/ .el-radio__input.is-checked .el-radio__inner {
      color: rgba(24, 144, 255, 1);
      border-color: rgba(24, 144, 255, 1);
      background: rgba(24, 144, 255, 1);
    }
    /deep/ .el-radio__input.is-checked + .el-radio__label {
      color: rgba(24, 144, 255, 1);
    }
  }
  .footer-wrap {
    text-align: right;
    display: block;
    padding-bottom: 24px;
  }
}
</style>
<style>
.el-loading-mask {
  z-index: 10000000;
}
</style>
